var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "page-header-wrapper padding-rb" },
        [
          _c(
            "PageHeader",
            { attrs: { title: "User List" } },
            [
              _c("el-input", {
                directives: [
                  {
                    name: "debounce",
                    rawName: "v-debounce",
                    value: _vm.onSearch,
                    expression: "onSearch",
                  },
                ],
                attrs: {
                  "prefix-icon": "el-icon-search",
                  placeholder: "Search",
                  clearable: "",
                },
                on: { clear: _vm.onSearch },
                model: {
                  value: _vm.searchVal,
                  callback: function ($$v) {
                    _vm.searchVal = $$v
                  },
                  expression: "searchVal",
                },
              }),
              !_vm.isSupervisor
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary", icon: "el-icon-plus" },
                      on: { click: _vm.handleNewUser },
                    },
                    [_vm._v(" New User ")]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-wrapper" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.tableLoading,
                  expression: "tableLoading",
                },
              ],
              ref: "SeTable",
              attrs: {
                size: "mini",
                "element-loading-text": "Loading...",
                data: _vm.tableData,
              },
              on: { "sort-change": _vm.onSortChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "No",
                  label: "No.",
                  sortable: "custom",
                  width: "80",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "Name",
                  label: "Name",
                  sortable: "custom",
                  "min-width": "100",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "LoginName",
                  label: "Login Name",
                  sortable: "custom",
                  "min-width": "140",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "Description",
                  label: "Role",
                  sortable: "custom",
                  "min-width": "90",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "TeamName",
                  label: "Team",
                  sortable: "custom",
                  "min-width": "110",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "Manager",
                  label: "Manager",
                  sortable: "custom",
                  "min-width": "120",
                  formatter: _vm.managerFormatter,
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "TaConfigName",
                  label: "TA",
                  sortable: "custom",
                  "min-width": "110",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "Phone",
                  label: "Phone",
                  sortable: "custom",
                  "min-width": "100",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "Email",
                  label: "Email",
                  sortable: "custom",
                  "min-width": "120",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "Operation", width: "110", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function ({ row }) {
                      return [
                        _c(
                          "OptionMenu",
                          {
                            attrs: {
                              icon: "iconfont icon-more-menu",
                              iconSize: "18",
                            },
                          },
                          [
                            _c("OptionMenuItem", {
                              attrs: { icon: "el-icon-edit", title: "Edit" },
                              on: {
                                click: function ($event) {
                                  return _vm.handleEditUser(row)
                                },
                              },
                            }),
                            _c("OptionMenuItem", {
                              attrs: {
                                icon: "el-icon-delete",
                                title: "Delete",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleDelete(row)
                                },
                              },
                            }),
                            _c("OptionMenuItem", {
                              attrs: {
                                icon: "el-icon-document",
                                title: "Operation History",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handleOperationLog(row)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrap" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.currentPage,
                  "page-sizes": [10, 25, 50, 100],
                  "page-size": _vm.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("NewUserDialog", {
        attrs: { visible: _vm.newUserDialogVisible },
        on: {
          "update:visible": function ($event) {
            _vm.newUserDialogVisible = $event
          },
          success: function ($event) {
            return _vm.onSuccess(true)
          },
        },
      }),
      _c("EditUserDialog", {
        attrs: { visible: _vm.editUserDialogVisible, data: _vm.editRow },
        on: {
          "update:visible": function ($event) {
            _vm.editUserDialogVisible = $event
          },
          "update:data": function ($event) {
            _vm.editRow = $event
          },
          success: _vm.onSuccess,
        },
      }),
      _c("UserOperationLogDialog", {
        attrs: {
          visible: _vm.operationLogDialogVisible,
          data: _vm.operationLogRow,
        },
        on: {
          "update:visible": function ($event) {
            _vm.operationLogDialogVisible = $event
          },
          "update:data": function ($event) {
            _vm.operationLogRow = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }